<template>
  <div>
    <navbar/>
  <downloads/>
  </div>
</template>

<script>

import downloads from '@/components/downloads.vue';
import navbar from '@/components/navbar.vue';

export default {
  name: 'DownloadView',
  components: {
    navbar, 
    downloads, 
  }
}
</script>
